import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M4.14 12.012a.748.748 0 0 1-.15-1.05l3.56-4.8a.01.01 0 0 0 .01-.01.535.535 0 0 1 .13-.13.236.236 0 0 1 .09-.06.713.713 0 0 1 .39-.12.816.816 0 0 1 .44.14l.01.01 1.64 1.19 3.14-4.24a.75.75 0 1 1 1.2.9l-3.57 4.8v.01a.74.74 0 0 1-.61.31.7.7 0 0 1-.44-.14l-.05-.03-1.6-1.16-3.14 4.23a.75.75 0 0 1-1.05.15Zm9.77 1.24H3.34a.585.585 0 0 1-.59-.59V2.092a.75.75 0 0 0-1.5 0v10.57a2.1 2.1 0 0 0 2.09 2.09h10.57a.75.75 0 0 0 0-1.5Zm-5.74-7.41a.816.816 0 0 1 .44.14.7.7 0 0 0-.44-.14Z';
const draw24px =
  'M20.92,21.67H5.08a2.76,2.76,0,0,1-2.75-2.75V3.08a.75.75,0,0,1,1.5,0V18.92a1.25,1.25,0,0,0,1.25,1.25H20.92a.75.75,0,0,1,0,1.5ZM21.5,4.43a.75.75,0,0,0-1.05.15l-4.93,6.63-2.75-2h0a1,1,0,0,0-.21-.1.66.66,0,0,0-.23,0,.74.74,0,0,0-.61.31h0L6.35,16.6A.74.74,0,0,0,7,17.79a.73.73,0,0,0,.6-.3l4.93-6.63,2.73,2,0,0a.7.7,0,0,0,.44.14.71.71,0,0,0,.6-.31l5.36-7.21A.75.75,0,0,0,21.5,4.43Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ChartLineIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'chartLine'),
) as IconWithRender;

ChartLineIcon.displayName = 'ChartLineIcon';
ChartLineIcon.propTypes = Icon.propTypes;
ChartLineIcon.renderIcon = (props) => <ChartLineIcon {...props} />;
export default ChartLineIcon;
